import { useEffect, useState } from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

import useMerchantVenues from './useMerchantVenues';

const useFetchAllMerchantVenues = (isEnabled: boolean, merchantId: string, pageSize?: number) => {
  const [venues, setVenues] = useState<Venue[]>([]);
  const {
    data,
    error,
    isLoading: isLoadingPage,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useMerchantVenues(isEnabled, merchantId, pageSize);

  useEffect(() => {
    if (isLoadingPage || isFetchingNextPage) {
      return;
    }

    if (hasNextPage) {
      fetchNextPage();
    } else {
      setVenues(data?.pages.flatMap(page => page.venues) || []);
    }
  }, [data?.pages, fetchNextPage, hasNextPage, isFetchingNextPage, isLoadingPage]);

  // including hasNextPage here since we're fetching all pages iteratively,
  // and we don't want to flicker between loading/loaded when fetching subsequent pages
  const isLoading = isLoadingPage || isFetchingNextPage || hasNextPage;
  return { venues, error, isLoading, hasNextPage };
};

export default useFetchAllMerchantVenues;
